module.exports = __webpack_public_path__ + "static/media/soul-logo.6ecda3b0.gif";